import { render, staticRenderFns } from "./CampaignSummaryModal.vue?vue&type=template&id=053ce09e&scoped=true&"
import script from "./CampaignSummaryModal.vue?vue&type=script&lang=js&"
export * from "./CampaignSummaryModal.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSummaryModal.vue?vue&type=style&index=0&id=053ce09e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053ce09e",
  null
  
)

export default component.exports